'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userIdentityShape = _reactImmutableProptypes2.default.contains({
  name: _react.PropTypes.string.isRequired,
  id: _react.PropTypes.number.isRequired,
  active: _react.PropTypes.bool.isRequired,
  avatar: _react.PropTypes.string,
  homeLibrary: _react.PropTypes.string.isRequired,
  homeLibrarySubdomain: _react.PropTypes.string.isRequired,
  homeLibraryFullName: _react.PropTypes.string.isRequired,
  homePatron: _react.PropTypes.bool.isRequired,
  staff: _react.PropTypes.bool.isRequired
});

exports.default = userIdentityShape;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/bc-prop-types/lib/components/userIdentityShape.js
// module id = 45
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14